import { MenuItem } from '@core/models';
import { NotificationTypeEnumValues } from '@core/interfaces/notification-message';

export class CheckoutValidationException extends Error {
	constructor(
		message: string,
		public readonly title: string,
		public readonly notificationType: NotificationTypeEnumValues,
		public readonly updatedCartItems?: MenuItem[]
	) {
		super(message);
		this.name = 'CheckoutValidationException';
	}
}
